import axios from "axios"
//import {browserHistory} from 'react-router';

// const
const APPLICATION_MARKET_MANAGEMENT_UPDATE_DATA = "applicationMarketManagement/APPLICATION_MARKET_MANAGEMENT_UPDATE_DATA";
const APPLICATION_MARKET_MANAGEMENT_STORE_APP_CATEGORIES = "applicationMarketManagement/APPLICATION_MARKET_MANAGEMENT_STORE_APP_CATEGORIES";
const APPLICATION_MARKET_MANAGEMENT_STORE_APP_ADVERTISEMENTS = "applicationMarketManagement/APPLICATION_MARKET_MANAGEMENT_STORE_APP_ADVERTISEMENTS";
const APPLICATION_MARKET_MANAGEMENT_STORE_APPLICATIONS = "applicationMarketManagement/APPLICATION_MARKET_MANAGEMENT_STORE_APPLICATIONS";
const APPLICATION_MARKET_MANAGEMENT_STORE_PAGE = "applicationMarketManagement/APPLICATION_MARKET_MANAGEMENT_STORE_PAGE";
const APPLICATION_MARKET_MANAGEMENT_TOGGLE_LOADING = "applicationMarketManagement/APPLICATION_MARKET_MANAGEMENT_TOGGLE_LOADING";

// reducer
export const applicationMarketManagement = (state = {
  loading: false,
  pageSize: 10,
  pageCurrent: 1,
  pageTotal: 0,
  selectedKey: "",

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  appCategories: [],
  appAdvertisements: [],
  applications: [],
  applicationId: "",

  appCategory: [],
  rangeDate: [],
  name: "",
}, action) => {
  switch (action.type) {
    case APPLICATION_MARKET_MANAGEMENT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case APPLICATION_MARKET_MANAGEMENT_STORE_APP_CATEGORIES:
      return {
        ...state,
        appCategories: action.data
      };
    case APPLICATION_MARKET_MANAGEMENT_STORE_APP_ADVERTISEMENTS:
      return {
        ...state,
        appAdvertisements: action.data
      };
    case APPLICATION_MARKET_MANAGEMENT_STORE_APPLICATIONS:
      return {
        ...state,
        applications: action.data
      };
    case APPLICATION_MARKET_MANAGEMENT_STORE_PAGE:
      return {
        ...state,
        pageCurrent: action.data.pageCurrent + 1,
        pageTotal: action.data.pageTotal,
        name: action.data.name,
      };
    case APPLICATION_MARKET_MANAGEMENT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateApplicationMarketManagementData = (data) => {
  return {
    type: APPLICATION_MARKET_MANAGEMENT_UPDATE_DATA,
    data: data
  }
};

/**
 * get all app categories
 */
export const getAppCategories = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/getApplicationCategoryTree", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAppCategories(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all app categories
 */
export const storeAppCategories = (appCategories) => {
  return {
    type: APPLICATION_MARKET_MANAGEMENT_STORE_APP_CATEGORIES,
    data: appCategories
  }
};
/**
 * get all app advertisements
 */
export const getAppAdvertisements = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/applicationAdvertisements", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAppAdvertisements(response.data._embedded.applicationAdvertisements));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all app advertisements
 */
export const storeAppAdvertisements = (appAdvertisements) => {
  return {
    type: APPLICATION_MARKET_MANAGEMENT_STORE_APP_ADVERTISEMENTS,
    data: appAdvertisements
  }
};

/**
 * get applications
 */
export const getApplications = (data) => (dispatch) => {
  console.log("query",data);
  dispatch(toggleLoading(true));
  let params = `?name=${data.name}` +
    `&parentCategory=${data.appCategory.length > 0 ? data.appCategory[0] : ""}` +
    `&category=${data.appCategory.length > 0 ? data.appCategory[1] : ""}` +
    `&beginDate=${data.rangeDate.length > 0 ? data.rangeDate[0] : ""}` +
    `&endDate=${data.rangeDate.length > 0 ? data.rangeDate[1] : ""}`;

  axios.get("/api-application/getApplicationByNameAndCategoryAndRangeDate" + params, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplications(response.data));
        // data.pageTotal = response.data.totalElements;
        // dispatch(storePage(data));
        dispatch(toggleLoading(false));
      }
      else{
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store applications
 */
export const storeApplications = (applications) => {
  return {
    type: APPLICATION_MARKET_MANAGEMENT_STORE_APPLICATIONS,
    data: applications
  }
};

/**
 * store page
 */
export const storePage = (page) => {
  return {
    type: APPLICATION_MARKET_MANAGEMENT_STORE_PAGE,
    data: page
  }
};

/**
 * offline application
 */
export const offlineApplication = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  // axios.get("/api-application/getApplicationCategoryTree", {contentType: "application/json"}).then(
  //   response => {
  //     if (response.data) {
  //       dispatch(storeAppCategories(response.data));
  //     }
  //   }
  // );

  dispatch(toggleLoading(false));
};

/**
 * top application
 */
export const topApplication = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  // axios.get("/api-application/getApplicationCategoryTree", {contentType: "application/json"}).then(
  //   response => {
  //     if (response.data) {
  //       dispatch(storeAppCategories(response.data));
  //     }
  //   }
  // );

  dispatch(toggleLoading(false));
};

/**
 * submit application market management data
 */
export const submitApplicationMarketManagementData = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  // axios.get("/api-application/getApplicationCategoryTree", {contentType: "application/json"}).then(
  //   response => {
  //     if (response.data) {
  //       dispatch(storeAppCategories(response.data));
  //     }
  //   }
  // );

  dispatch(toggleLoading(false));
};
/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: APPLICATION_MARKET_MANAGEMENT_TOGGLE_LOADING,
    data: show
  }
};
